import {inject, Injectable} from '@angular/core';
import {ApiService} from "../api/api.service";
import {ToastService} from "../toast/toast.service";
import {TranslateService} from "@ngx-translate/core";
import {PageableDocuments} from "../../models";
import {HttpResponse} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
    private apiService = inject(ApiService);
    private toastService = inject(ToastService);
    private translateService = inject(TranslateService);

    public getProjectDocuments(page: number, pageSize: number, projectId: number): Promise<PageableDocuments> {
        return new Promise((resolve, reject) => {
            this.apiService.get(`/projects/${projectId}/documents?page=${page}&size=${pageSize}`).then((projectResponse: HttpResponse<PageableDocuments>) => {
                resolve(projectResponse.body);
            }).catch((error) => {
                this.toastService.openError(error.status, this.translateService.instant('ERRORS.documents_not_updated'));
                reject(error);
            });
        });
    }
}
